import React, { useState } from 'react';
import { SortableList } from './SortableList';

interface ExampleItem {
  id: string;
  band: string;
  members: string;
  year: string;
  country: string;
}

const items: ExampleItem[] = [
  {
    id: '1',
    band: 'The Beatles',
    members: '4',
    year: '1960',
    country: 'United Kingdom',
  },
  {
    id: '2',
    band: 'The Rolling Stones',
    members: '4',
    year: '1962',
    country: 'United Kingdom',
  },
  {
    id: '3',
    band: 'Nirvana',
    members: '3',
    year: '1987',
    country: 'United States',
  },
];

export function SortableListMultiselectExample(): JSX.Element {
  const [selectedRows, setSelectedRows] = useState<ExampleItem[]>([]);

  function handleOnRowSelect(row: ExampleItem): void {
    const exists = selectedRows.find((item) => item.id === row.id);

    if (!exists) {
      setSelectedRows([...selectedRows, row]);
    } else {
      setSelectedRows(selectedRows.filter((item) => item.id !== row.id));
    }
  }

  function handleOnSelectAll(): void {
    if (selectedRows.length === items.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(items);
    }
  }

  return (
    <SortableList
      items={items}
      multiSelect
      onRowSelect={handleOnRowSelect}
      selectedItems={selectedRows}
      onSelectAll={handleOnSelectAll}
      columns={[
        { label: 'Band', sortable: false, dataKey: 'band' },
        {
          label: 'Number of members',
          sortable: true,
          dataKey: 'members',
          sortRenderer: (row) => row.year,
        },
        {
          label: 'Country of origin',
          sortable: false,
          dataKey: 'country',
        },
      ]}
    />
  );
}
